import { useState } from 'react';

const TESTIMONIALS = [
  {
    id: 1,
    name: 'Michael R.',
    location: 'Tampa, FL',
    rating: 5,
    project: 'Hardwood Floor Installation',
    text: 'VM Construction completely transformed our living room. The hardwood floors are absolutely stunning — perfect lines, zero gaps, and they cleaned up everything before leaving. Couldn\'t be happier with the result.',
    avatar: 'MR',
  },
  {
    id: 2,
    name: 'Sandra L.',
    location: 'St. Petersburg, FL',
    rating: 5,
    project: 'Bathroom Remodel',
    text: 'From demo to final tile, these guys were professional every single day. They showed up on time, communicated every step, and the bathroom looks like something out of a magazine. Highly recommend!',
    avatar: 'SL',
  },
  {
    id: 3,
    name: 'James T.',
    location: 'Sarasota, FL',
    rating: 5,
    project: 'LVP Installation + Subfloor Prep',
    text: 'Other contractors wanted to skip the subfloor issues. VM Construction fixed everything properly before installing. Two years later, not a single creak or lift. That\'s the difference between doing it right and doing it fast.',
    avatar: 'JT',
  },
  {
    id: 4,
    name: 'Patricia M.',
    location: 'Clearwater, FL',
    rating: 5,
    project: 'Dustless Tile Removal',
    text: 'I was worried about the dust and mess. They brought in their dustless system and my house stayed clean the entire time. Removed 1,200 sq ft of old tile in two days. Absolutely incredible.',
    avatar: 'PM',
  },
  {
    id: 5,
    name: 'Carlos V.',
    location: 'Brandon, FL',
    rating: 5,
    project: 'Herringbone Flooring',
    text: 'The herringbone pattern they installed is a work of art. Every cut is perfect, every angle is exact. My guests always ask who did the floors. VM Construction is the only answer I give.',
    avatar: 'CV',
  },
  {
    id: 6,
    name: 'Diana K.',
    location: 'Wesley Chapel, FL',
    rating: 5,
    project: 'Full Home Flooring',
    text: 'They replaced flooring in our entire 2,800 sq ft home in under a week. The crew was respectful, tidy, and the quality is exceptional. Best investment we\'ve made in this house.',
    avatar: 'DK',
  },
];

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const visible = [
    TESTIMONIALS[active % TESTIMONIALS.length],
    TESTIMONIALS[(active + 1) % TESTIMONIALS.length],
    TESTIMONIALS[(active + 2) % TESTIMONIALS.length],
  ];

  return (
    <section className="bg-[#faf8f5] py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="text-[#c9a55a] text-xs font-bold uppercase tracking-[0.3em] mb-3">Client Reviews</p>
            <h2 className="text-3xl md:text-4xl font-black text-[#1c1a17] leading-tight">
              What Our Clients Say
            </h2>
          </div>
          {/* Stars summary */}
          <div className="flex items-center gap-4 bg-white border border-[#e5e0d8] rounded-2xl px-6 py-4 flex-shrink-0">
            <div className="text-center">
              <div className="text-3xl font-black text-[#1c1a17]">5.0</div>
              <div className="flex items-center gap-0.5 mt-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#c9a55a] text-sm" />
                ))}
              </div>
              <div className="text-[#6b6560] text-xs mt-1">Google Rating</div>
            </div>
            <div className="w-px h-12 bg-[#e5e0d8]" />
            <div className="text-center">
              <div className="text-3xl font-black text-[#1c1a17]">2,000+</div>
              <div className="text-[#6b6560] text-xs mt-2">Happy Clients</div>
            </div>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {visible.map((t, idx) => (
            <div
              key={`${t.id}-${idx}`}
              className="bg-white border border-[#e5e0d8] rounded-2xl p-7 flex flex-col gap-4 transition-all duration-300"
            >
              {/* Stars */}
              <div className="flex items-center gap-1">
                {[...Array(t.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#c9a55a] text-sm" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-[#4a4540] text-sm leading-relaxed flex-1">
                &ldquo;{t.text}&rdquo;
              </p>

              {/* Project tag */}
              <div className="inline-flex items-center gap-2 bg-[#f4f0ea] rounded-full px-3 py-1 w-fit">
                <i className="ri-tools-line text-[#c9a55a] text-xs" />
                <span className="text-[#6b6560] text-xs font-medium">{t.project}</span>
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-2 border-t border-[#f0ece6]">
                <div className="w-10 h-10 flex items-center justify-center bg-[#c9a55a]/15 rounded-full flex-shrink-0">
                  <span className="text-[#c9a55a] text-xs font-black">{t.avatar}</span>
                </div>
                <div>
                  <div className="text-[#1c1a17] font-bold text-sm">{t.name}</div>
                  <div className="text-[#9c9490] text-xs">{t.location}</div>
                </div>
                <div className="ml-auto w-6 h-6 flex items-center justify-center">
                  <i className="ri-google-fill text-[#6b6560] text-base" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination dots */}
        <div className="flex items-center justify-center gap-3">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              type="button"
              onClick={() => setActive(i)}
              className={`transition-all duration-300 rounded-full cursor-pointer ${
                i === active % TESTIMONIALS.length
                  ? 'w-8 h-2 bg-[#c9a55a]'
                  : 'w-2 h-2 bg-[#d0cbc5] hover:bg-[#c9a55a]/50'
              }`}
              aria-label={`Review ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
